"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable camelcase */
var rest_1 = __importDefault(require("../../rest"));
var registrationData_1 = __importDefault(require("../mock/tournaments/registrationData"));
var tournamentProgressState_1 = __importDefault(require("../mock/tournaments/tournamentProgressState"));
var tournamentState_1 = __importDefault(require("../mock/tournaments/tournamentState"));
var tournamentUsers_1 = __importDefault(require("../mock/tournaments/tournamentUsers"));
var upcomingTournaments_1 = __importDefault(require("../mock/tournaments/upcomingTournaments"));
var tournamentResults_1 = __importDefault(require("../mock/tournaments/tournamentResults"));
var pastTournaments_1 = __importDefault(require("../mock/tournaments/pastTournaments"));
var leaderboard_1 = require("../mock/tournaments/leaderboard");
var coreServiceUrl = process.env.CB_CORE_SERVICE_SERVER_URL;
var TournamentsAPI = {
    getTournamentCurrentState: function (token, uuid, leaderboardOffset, leaderboardLimit, mockParams) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.get({
                    mockFunc: function () { return (0, tournamentState_1.default)(__assign(__assign({}, mockParams), { leaderboardLimit: leaderboardLimit })); },
                    url: "".concat(coreServiceUrl, "/tournaments/current-state/").concat(uuid, "?leaderboardOffset=").concat(leaderboardOffset, "&leaderboardLimit=").concat(leaderboardLimit),
                    token: token,
                })];
        });
    }); },
    getMyCurrentState: function (token, uuid, leaderboardOffset, leaderboardLimit, mockParams) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.get({
                    mockFunc: function () { return (0, tournamentProgressState_1.default)(__assign(__assign({}, mockParams), { leaderboardLimit: leaderboardLimit })); },
                    url: "".concat(coreServiceUrl, "/tournaments/my-current-state/").concat(uuid, "?leaderboardOffset=").concat(leaderboardOffset, "&leaderboardLimit=").concat(leaderboardLimit),
                    token: token,
                })];
        });
    }); },
    startRound: function (token, uuid, inMinutes) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () { return ({ success: true }); },
                    url: "".concat(coreServiceUrl, "/tournaments/start-round/").concat(uuid),
                    token: token,
                    body: { inMinutes: inMinutes },
                })];
        });
    }); },
    startRoundNow: function (token, uuid) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () { return ({ success: true }); },
                    url: "".concat(coreServiceUrl, "/tournaments/start-round-now/").concat(uuid),
                    token: token,
                })];
        });
    }); },
    joinTournament: function (token, uuid, nickname, avatar, framework) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () { return ({ success: true }); },
                    url: "".concat(coreServiceUrl, "/tournaments/join-tournament"),
                    token: token,
                    body: { tournamentUuid: uuid, nickname: nickname, avatar: avatar, framework: framework },
                })];
        });
    }); },
    timesync: function (token, id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () { return ({ id: id, result: Date.now() }); },
                    url: "".concat(coreServiceUrl, "/tournaments/timesync"),
                    token: token,
                    body: { id: id },
                })];
        });
    }); },
    getRegistrationData: function (token, uuid) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.get({
                    mockFunc: function () { return (0, registrationData_1.default)(); },
                    url: "".concat(coreServiceUrl, "/tournaments/registration-data/").concat(uuid),
                    token: token,
                })];
        });
    }); },
    revealAnswerNow: function (token, uuid) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () { return ({ success: true }); },
                    url: "".concat(coreServiceUrl, "/tournaments/reveal-answer-now/").concat(uuid),
                    token: token,
                })];
        });
    }); },
    submitAnswer: function (token, uuid, answers) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () { return ({ success: true }); },
                    url: "".concat(coreServiceUrl, "/tournaments/submit-answer/").concat(uuid),
                    token: token,
                    body: { answers: answers },
                })];
        });
    }); },
    getUpcomingTournaments: function (token) {
        return rest_1.default.get({
            mockFunc: function () { return upcomingTournaments_1.default; },
            url: "".concat(coreServiceUrl, "/upcoming-tournaments"),
            token: token,
        });
    },
    getPastTournaments: function (token) {
        return rest_1.default.get({
            mockFunc: function () { return pastTournaments_1.default; },
            url: "".concat(coreServiceUrl, "/past-tournaments"),
            token: token,
        });
    },
    getTournamentUsers: function (token, uuid, options) { return __awaiter(void 0, void 0, void 0, function () {
        var offset, limit, withUserStatuses, queryParams, params;
        return __generator(this, function (_a) {
            offset = options.offset, limit = options.limit, withUserStatuses = options.withUserStatuses;
            queryParams = new URLSearchParams(__assign(__assign(__assign({}, (offset !== undefined && { offset: String(offset) })), (limit !== undefined && { limit: String(limit) })), (withUserStatuses && { withUserStatuses: withUserStatuses.toString() })));
            params = queryParams.toString();
            return [2 /*return*/, rest_1.default.get({
                    mockFunc: function () { return tournamentUsers_1.default; },
                    url: "".concat(coreServiceUrl, "/tournaments/all-users/").concat(uuid).concat(params ? "?".concat(params) : ''),
                    token: token,
                })];
        });
    }); },
    getLeaderboard: function (token, uuid, options, mockParams) { return __awaiter(void 0, void 0, void 0, function () {
        var offset, limit, queryParams, params;
        return __generator(this, function (_a) {
            offset = options.offset, limit = options.limit;
            queryParams = new URLSearchParams(__assign(__assign({}, (offset !== undefined && { offset: String(offset) })), (limit !== undefined && { limit: String(limit) })));
            params = queryParams.toString();
            return [2 /*return*/, rest_1.default.get({
                    mockFunc: function () { return (__assign({ success: true }, (0, leaderboard_1.getLeaderboardPage)(limit || 10, offset || 0, mockParams.isAdmin))); },
                    url: "".concat(coreServiceUrl, "/tournaments/leaderboard/").concat(uuid).concat(params ? "?".concat(params) : ''),
                    token: token,
                })];
        });
    }); },
    getStatisticsLeaderboard: function (token, uuid, options, mockParams) { return __awaiter(void 0, void 0, void 0, function () {
        var offset, limit, searchString, queryParams, params;
        return __generator(this, function (_a) {
            offset = options.offset, limit = options.limit, searchString = options.searchString;
            queryParams = new URLSearchParams(__assign(__assign(__assign({}, (offset !== undefined && { offset: String(offset) })), (limit !== undefined && { limit: String(limit) })), (searchString !== undefined && { search_string: String(searchString) })));
            params = queryParams.toString();
            return [2 /*return*/, rest_1.default.get({
                    mockFunc: function () { return (__assign({ success: true }, (0, leaderboard_1.getLeaderboardPage)(limit || 10, offset || 0, mockParams.isAdmin))); },
                    url: "".concat(coreServiceUrl, "/tournaments/statistics/leaderboard/").concat(uuid).concat(params ? "?".concat(params) : ''),
                    token: token,
                })];
        });
    }); },
    getTournamentResults: function (token, tournamentUuid) {
        return rest_1.default.get({
            mockFunc: function () { return tournamentResults_1.default; },
            url: "".concat(coreServiceUrl, "/tournaments/user-results/").concat(tournamentUuid),
            token: token,
        });
    },
    openTournament: function (token, tournamentUuid) {
        return rest_1.default.post({
            mockFunc: function () { return ({ success: true }); },
            url: "".concat(coreServiceUrl, "/tournaments/open/").concat(tournamentUuid),
            token: token,
        });
    },
    deleteTournament: function (token, tournamentUuid) {
        return rest_1.default.delete({
            mockFunc: function () { return ({ success: true }); },
            url: "".concat(coreServiceUrl, "/tournaments/").concat(tournamentUuid),
            token: token,
        });
    },
    createTournament: function (token, body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () { return ({ success: true }); },
                    url: "".concat(coreServiceUrl, "/tournaments"),
                    body: body,
                    token: token,
                })];
        });
    }); },
    sharedLink: function (token, tournamentUuid) {
        return rest_1.default.patch({
            mockFunc: function () { return ({ success: true }); },
            url: "".concat(coreServiceUrl, "/tournaments/share-link/").concat(tournamentUuid),
            token: token,
        });
    },
};
exports.default = TournamentsAPI;
